import type {
  ReactElement,
} from 'react';

import styled from 'styled-components';

import { wrapMenuList } from 'react-select-async-paginate';

import type {
  MenuListProps,
} from 'react-select';

import type {
  OptionTypeBase,
} from '../types';

const Wrapper = styled.div(({
  theme: {
    indents,
  },
}) => ({
  overflowY: 'auto',
  position: 'relative',
  WebkitOverflowScrolling: 'touch',
  boxSizing: 'border-box',
  paddingTop: indents.INDENT_1,
  paddingBottom: indents.INDENT_1,
}));

export function MenuList<
OptionType extends OptionTypeBase,
IsMulti extends boolean,
>({
  children,
  maxHeight,
  innerRef,
  className,
}: MenuListProps<OptionType, IsMulti>): ReactElement {
  return (
    <Wrapper
      className={className}
      style={{
        maxHeight,
      }}
      ref={innerRef}
      data-n3__select-menu=""
    >
      {children}
    </Wrapper>
  );
}

export const WrappedMenuList = wrapMenuList(MenuList);
